import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getSummary(fiscalYear) {
        try{            
            const response = await axios.get(`ProjectReports/summary/${fiscalYear}`, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })         
            return response
        }catch (error){
            console.log('ProjectReports getSummary api error: ', error)
            throw error
        }
    },
    async getTask(data) {
        try{            
            const response = await axios.get(`ProjectReports/${data.projectId}/${data.fiscalYear}`, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })         
            return response
        }catch (error){
            console.log('ProjectReports getTask api error')
            throw error
        }
    },
    async getEmployeeSummary(fiscalYear) {
        try{            
            const response = await axios.get(`ProjectReports/employees/${fiscalYear}`, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })         
            return response
        }catch (error){
            console.log('ProjectReports getEmployeeSummary api error')
            throw error
        }
    },
    async getEmployeeDetails(data) {
        try{            
            const response = await axios.get(`ProjectReports/employees/${data.fiscalYear}/${data.userId}`, {
                headers: {
                    'page_key': pageKeys.projects
                }
            })         
            return response
        }catch (error){
            console.log('ProjectReports getEmployeeDetails api error')
            throw error
        }
    },
}